import { GraphQLS3FileRepository } from "@app/repositories/GraphQLRepositories/S3FileRepository";
import { useMutation } from "@tanstack/react-query";

const s3FileRepository = new GraphQLS3FileRepository();

export const useDeleteFile = () =>
    useMutation({
        mutationFn: s3FileRepository.deleteOne,
    });
